import { Flex, IconButton, Text } from "@chakra-ui/react";
import IconRight from "assets/img/icons/Icon-right.svg";

interface ActionsColumnProps {
  onViewDetails: () => void;
}

export const ActionsColumn = ({ onViewDetails }: ActionsColumnProps) => {
  return (
    <Flex align="center" justifyContent="flex-start">
      <Text
        color="#0B0E10"
        fontSize="14px"
        fontWeight="400"
        cursor="pointer"
        _hover={{ textDecoration: "underline" }}
        onClick={(e) => {
          e.stopPropagation();
          onViewDetails();
        }}
      >
        View details
      </Text>
      <IconButton
        aria-label="arrow"
        bg="transparent"
        size="sm"
        minW="14px"
        h="4px"
        onClick={(e) => {
          e.stopPropagation();
          onViewDetails();
        }}
        _active={{
          bg: "transparent",
        }}
        _hover={{
          bg: "transparent",
        }}
        _focus={{
          boxShadow: "none",
        }}
        icon={
          <img
            src={IconRight}
            alt="arrow"
            width="6"
            height="6"
            style={{ marginLeft: "8px" }}
          />
        }
      />
    </Flex>
  );
};
